import { useState, useEffect } from 'react';
import { supabase } from './lib/supabase';
import { exportData } from './db';
import Login from './components/Login';
import Patients from './sections/Patients';
import Suppliers from './sections/Suppliers';
import Products from './sections/Products';
import Treatments from './sections/Treatments';
import Prescriptions from './sections/Prescriptions';
import Consultations from './sections/Consultations';
import Supplements from './sections/Supplements';
import Import from './sections/Import';
import Stock from './sections/Stock';
import FixedCosts from './sections/FixedCosts';
import { TodoList, FridgeCheck } from './sections/Utils';
import {
  Users, Truck, Package, Scissors, FileText, CheckSquare,
  Thermometer, BarChart2, Download, Menu, X, ClipboardList, Leaf, LogOut, UploadCloud, PoundSterling
} from 'lucide-react';
import './App.css';

const NAV = [
  { id: 'consultations', label: 'Consultations', icon: ClipboardList },
  { id: 'patients', label: 'Clients', icon: Users },
  { id: 'treatments', label: 'Treatments', icon: Scissors },
  { id: 'products', label: 'Products', icon: Package },
  { id: 'supplements', label: 'Supplements', icon: Leaf },
  { id: 'suppliers', label: 'Suppliers', icon: Truck },
  { id: 'prescriptions', label: 'Prescriptions', icon: FileText },
  { id: 'stock', label: 'Stock', icon: BarChart2 },
  { id: 'fixedcosts', label: 'Fixed Costs', icon: PoundSterling },
  { id: 'todos', label: 'To-Do', icon: CheckSquare },
  { id: 'fridge', label: 'Fridge', icon: Thermometer },
];

export default function App() {
  const [session, setSession] = useState(undefined);
  const [active, setActive] = useState('consultations');
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => setSession(session));
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_e, session) => setSession(session));
    return () => subscription.unsubscribe();
  }, []);

  if (session === undefined) return (
    <div className="loading-screen">
      <div className="loading-logo">DA</div>
      <div className="loading-text">Dorset Aesthetics Hub</div>
      <div className="loading-sub">Loading...</div>
    </div>
  );

  if (!session) return <Login />;

  const ActiveSection = () => {
    switch (active) {
      case 'consultations': return <Consultations />;
      case 'patients': return <Patients />;
      case 'treatments': return <Treatments />;
      case 'products': return <Products />;
      case 'supplements': return <Supplements />;
      case 'suppliers': return <Suppliers />;
      case 'prescriptions': return <Prescriptions />;
      case 'stock': return <StockList />;
      case 'todos': return <TodoList />;
      case 'fridge': return <FridgeCheck />;
      case 'stock': return <Stock />;
      case 'fixedcosts': return <FixedCosts />;
      case 'import': return <Import />;
      default: return <Consultations />;
    }
  };

  return (
    <div className="app-shell">
      <aside className={`sidebar ${menuOpen ? 'open' : ''}`}>
        <div className="sidebar-logo">
          <div className="logo-mark">DA</div>
          <div className="logo-text-block">
            <div className="logo-name">Dorset Aesthetics</div>
            <div className="logo-sub">Hub</div>
          </div>
        </div>
        <nav className="sidebar-nav">
          {NAV.map(item => (
            <button key={item.id} className={`nav-item ${active === item.id ? 'active' : ''}`}
              onClick={() => { setActive(item.id); setMenuOpen(false); }}>
              <item.icon size={17} />
              <span>{item.label}</span>
            </button>
          ))}
        </nav>
        <div className="sidebar-footer">
          <button className="nav-item" onClick={() => { setActive('import'); setMenuOpen(false); }}>
            <UploadCloud size={17} /><span>Import Data</span>
          </button>
          <button className="nav-item" onClick={exportData}>
            <Download size={17} /><span>Backup Data</span>
          </button>
          <button className="nav-item" onClick={() => supabase.auth.signOut()}>
            <LogOut size={17} /><span>Sign Out</span>
          </button>
        </div>
      </aside>

      <div className="mobile-header">
        <button className="mobile-menu-btn" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
        <div className="mobile-logo">DA · {NAV.find(n => n.id === active)?.label}</div>
      </div>

      {menuOpen && <div className="mobile-overlay" onClick={() => setMenuOpen(false)} />}

      <main className="main-content">
        <ActiveSection />
      </main>
    </div>
  );
}
